import { useState, useEffect } from 'react';
import { collection, query, where, getDocs, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseClient';

export const useProfiles = (role = null) => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let q = collection(db, 'profiles');

    // Filter by role if specified
    if (role) {
      const roleField = `is_${role}`;
      q = query(q, where(roleField, '==', true));
    }

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const profilesData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          created_at: doc.data().created_at?.toDate?.() || new Date(),
        }));
        setProfiles(profilesData);
        setLoading(false);
        setError(null);
      },
      (error) => {
        console.error('Error fetching profiles:', error);
        setError(error);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [role]);

  const getProfilesByRole = (targetRole) => {
    const roleField = `is_${targetRole}`;
    return profiles.filter(profile => profile[roleField] === true);
  };

  const getWriters = () => getProfilesByRole('writer');
  const getAdmins = () => getProfilesByRole('admin');
  const getQAUsers = () => getProfilesByRole('qa');
  const getClients = () => getProfilesByRole('client');

  return {
    profiles,
    loading,
    error,
    getProfilesByRole,
    getWriters,
    getAdmins,
    getQAUsers,
    getClients,
  };
};